import BigNumber from 'bn.js'
import { createContext } from 'react'

export interface CurrencyBalance {
  balance?: BigNumber
  busy?: boolean
  geotokensAllowance?: BigNumber
  minterAllowance?: BigNumber
  refresh?: () => void
}

export const CurrencyBalanceContext = createContext<CurrencyBalance>({})
